module.exports = __webpack_public_path__ + "static/img/img_gzhj2_2x.388a35b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/aboutus/img/img_gzhj2_2x.jpg
// module id = y2c9
// module chunks = 0